<lib-ribera-loader-ui [loader]="spinner.loading()" ></lib-ribera-loader-ui>
<div class="layout-wrapper">
  <lib-sidebar></lib-sidebar>
  <div class="layout-main">
      <lib-header></lib-header>
      <div class="content-main ">
        <router-outlet></router-outlet>
      </div>
  </div>
</div>

